// src/components/store/sections/newsletter/NewsletterV23ClaysubscribeSlateGold.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV23ClaysubscribeSlateGold(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={23}
      archKey="clay_subscribe"
      archLabel="3D Clay Subscribe Box"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
